import React, { useState } from 'react';
import SmallStagechart from '../SmallStagechart';
import LargeFlowChart from '../LargeFlowChart';
import LargeStageChart from '../LargeStageChart';
import Modal from "../Modal";
import useToggle from '../UseModal';
import Damages2 from '../Damages2';
import Buildings2 from '../Buildings2';
import { Col, Row } from 'react-bootstrap';
import moment from 'moment';



const Forecast = (props) => {

    // hooks for local modal state (shown or hidden)
    const [open, setOpen] = useToggle(false);
    const [type, setChartType] = useState(null);



    function handleChartClick(type) {

        setChartType(type);
        setOpen();
    }

    const activateOnKey = (handler) => (e) => {
        if (e.key === 'Enter' || e.key === ' ') {
            e.preventDefault();
            handler();
        }
    };

    function toggleModal() {
        if (open) {
            props.setBuildingMarker(null);
        }

        setOpen();
    }

    const isIE = /*@cc_on!@*/false || !!document.documentMode;
    const isChrome = !!window.chrome && (!!window.chrome.webstore || !!window.chrome.runtime);
    const isEdge = !isIE && !!window.StyleMedia;

    return (
        <div>
            {/* if a gage is selected (props passed w/ current gage name), return dashboard container.  Else return empty fragment. */}
            {props.gageName ?
                <div >
                    <h5 id="dashboardTitle">{props.gageName}</h5>
                    <div >
                        <p className="gageInfo">
                            <span className="gageInfoItem">Gage ID: <a id="gageLink" href={`https://water.noaa.gov/gauges/RONV2#hg=official`} target="new">{props.usgsGageID}</a></span>
                            {props.gageDatum ? <span className="gageInfoItem">Datum: {props.gageDatum}ft <br /> </span> : <div></div>}
                            {/*<span className="gageInfoItem">Owner: USGS</span>*/}
                        </p>

                    </div>
                    <Row >
                        <Col md={3} lg={3} xl={12} className="dashboardRow">
                            <div className="dashboardItem">
                                <h6>Forecast Status</h6>
                                <div className="dashboardStats">
                                    {props.gageDatum && props.forecastSliderValue ?
                                        <div>
                                            <div>Stage: <span className="boldValues">{(parseFloat(props.forecastStageValue)).toFixed(1)}</span> ft. </div>
                                            <div>Elevation: <span className="boldValues">{(parseFloat(props.forecastStageValue) + parseFloat(props.gageDatum)).toFixed(1)}</span> ft. <small>NAVD88</small></div>
                                            <div>Date/Time: <span className="boldValues">{props.forecastDateReading ? moment(props.forecastDateReading).format('lll') : null}</span></div>
                                        </div>
                                        :
                                        (props.observedStageData && props.observedStageData[props.observedStageData.length - 1].value ?
                                                <div>
                                                    <div>Stage: <span className="boldValues">{props.observedStageData[props.observedStageData.length - 1].value}</span> ft.</div>
                                                    <div>Elevation: <span className="boldValues">{(parseFloat(props.gageDatum) + parseFloat(props.observedStageData[props.observedStageData.length - 1].value)).toFixed(1)}</span> ft. <small>NAVD88</small></div>
                                                    <div>Date/Time: <span className="boldValues"> {(props.observedStageData && props.observedStageData[props.observedStageData.length - 1].dateTime) ? moment().format('lll') : null}</span></div>
                                                </div>
                                                :
                                            <div>
                                                <div>Stage: No Stage Data Available</div>
                                                <div>Elevation: No Elevation Data Available</div>
                                                <div>Date/Time: No Date/Time Available</div>

                                            </div>
                                        )
                                    }
                                </div>
                            </div>
                        </Col>
                        <Col md={3} lg={3} xl={12} className="dashboardRow">
                            <div className="dashboardItem">
                                <h6><a id="nwsLink" href={`https://water.noaa.gov/gauges/RONV2#hg=official`} target="new">NWS Forecast Info </a></h6>
                                <p className="dashboardStats">
                                    Max Stage: {props.peakStage ? props.peakStage : null} ft 
                                    <br></br>
                                    <span>Max Elevation: {props.peakElevation ? parseFloat(props.peakElevation).toFixed(1) : null} ft </span>
                                    <br></br>
                                    <span>Peak: {props.peakDateTime ? moment(props.peakDateTime).format('lll') : null} </span>

                                </p>

                            </div>
                        </Col>
                        <Col md={3} lg={3} xl={12} className="dashboardRow">
                            <div key={"stageForecastTable"} className="dashboardItem clickableDashboardItem" >
                                <h6>Impact Assessment</h6>
                                <div role="button" tabIndex={0} aria-label="Open impact assessment details" onClick={() => handleChartClick('impact')} onKeyDown={activateOnKey(() => handleChartClick('impact'))}>
                                    <Damages2 buildings={props.buildingsForecast} criticalBuildings={props.buildingsForecastCritical} elevation={props.gageDatum && props.forecastSliderValue ? parseFloat(props.forecastSliderValue).toFixed(1) : null } />
                                </div>
                            </div>
                        </Col>
                        <Col md={3} lg={3} xl={12} className="dashboardRow">
                            <div key={"stageForecastChart"} className="dashboardItem clickableDashboardItem" >
                                <h6>Stage Chart (ft)</h6>
                                { (props.observedStageData && props.observedStageData.length > 1)?
                                    <div role="button" tabIndex={0} aria-label="Open stage chart details" onClick={() => handleChartClick('stage')} onKeyDown={activateOnKey(() => handleChartClick('stage'))}>
                                        <SmallStagechart levels={props.stageLevels} data={props.observedStageData} forecastData={props.forecastStageData} />
                                    </div>
                                    :
                                    <p>No Stage Data Available</p>
                                }
                            </div>
                        </Col>
                    </Row>
                    <Modal
                        open={open}
                        toggle={toggleModal}
                    >
                        <div>
                            {type === 'impact' ?
                                <div>
                                    <h4 className="largeChartTitle draggable cursor">Impact Assesment</h4>
                                    <Buildings2 buildings={props.buildingsForecast} setBuildingMarker={props.setBuildingMarker} setCenterAndZoom={props.setCenterAndZoom} />
                                </div>
                                :
                                type === 'stage' ?
                                    <div>
                                        <h4 className={isEdge || isChrome ? "largeChartTitle draggable cursor" : "largeChartTitle"}>{props.gageName}</h4>
                                        <p>Stage Conditions</p>
                                        <LargeStageChart levels={props.stageLevels} data={props.observedStageData} forecastData={props.forecastStageData}></LargeStageChart>
                                    </div>
                                    :
                                    <div>
                                        <h4 className={isEdge || isChrome ? "largeChartTitle draggable cursor" : "largeChartTitle"}>{props.gageName}</h4>
                                        <p>Flow Conditions</p>
                                        <LargeFlowChart data={props.observedFlowData} forecastData={props.forecastFlowData}></LargeFlowChart>
                                    </div>
                            }
                        </div>
                    </Modal>

                </div>
                :
                <div>
                    <h5 id="dashboardMessage">Click a gage to get started</h5>
                    <div >
                        <p className="gageInfo">
                            <span className="gageInfoItem">Please select the Walnut Ave gage (large colored circle) on the map to view its current stage and flow data...</span>
                        </p>
                    </div>
                </div>
            }
        </div>
    );
};

export default Forecast;


// WEBPACK FOOTER //
// ./src/components/Forecast/index.js